import type { FilterValue } from '@/components/category-refinements/types';

function normalizeSearchQuery(query: string): string {
    return query.trim().toLocaleLowerCase();
}

export function filterRefinementValues(values: FilterValue[], query: string): FilterValue[] {
    const normalizedQuery = normalizeSearchQuery(query);
    if (!normalizedQuery) {
        return values;
    }

    return values.filter((item) => {
        const label = (item.label ?? item.value ?? '').toLocaleLowerCase();
        const value = (item.value ?? '').toLocaleLowerCase();
        return label.includes(normalizedQuery) || value.includes(normalizedQuery);
    });
}
